module.exports = __webpack_public_path__ + "static/media/building.5fa90b7b.png";